import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createExpense } from "../api";
import useCurrentUser from "../hooks/useCurrentUser";
import { hasPermission } from "../utils/permissions";
import InlineLoading from "../components/InlineLoading";
import { notify } from '../utils/alertBus';

const StockExpenseCreationPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const branchId = useParams().branchId || localStorage.getItem('selectedBranchId');
  const { user } = useCurrentUser();
  const canCreateStock = hasPermission(user, "stock.create");

  const handleSave = async () => {
    if (!canCreateStock) return;
    if (!title || !amount) {
      notify("Por favor, completa título y monto.");
      return;
    }

    setLoading(true);
    try {
      await createExpense(branchId, {
        title,
        amount: parseFloat(amount),
        description,
        stockListId: id,
      });

      notify("Gasto registrado exitosamente.");
      navigate(`/branches/${branchId}/stock/${id}`)
    } catch (error) {
      console.error("Error al registrar el gasto:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
        <h1 className="text-2xl font-bold text-center mb-6">Registrar Gasto</h1>

        {/* Title Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Título</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="border border-gray-300 rounded p-2 w-full"
            placeholder="Ejemplo: Transporte"
            disabled={!canCreateStock}
          />
        </div>

        {/* Amount Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Monto</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="border border-gray-300 rounded p-2 w-full"
            placeholder="Ejemplo: 50000"
            disabled={!canCreateStock}
          />
        </div>

        {/* Description Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Descripción</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="border border-gray-300 rounded p-2 w-full h-24"
            placeholder="Ejemplo: Pago de transporte para distribución"
            disabled={!canCreateStock}
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-2">
          <button
            onClick={() => navigate(`/branches/${branchId}/stock/${id}`)}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancelar
          </button>
          {canCreateStock && (
            <button
              onClick={handleSave}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              disabled={loading}
            >
              {loading ? <InlineLoading label="Guardando" /> : "Guardar"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StockExpenseCreationPage;
